import { Grid, styled } from '@mui/material';

export const VerificationsTableWrapper = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(3),
  width: '100%',
  overflow: 'auto'
}));
